const account = (state = {}, action) => {
	switch (action.type) {
		case "SET_ACCOUNT":
			return action.account ? { ...action.account } : null;
		default:
			return state;
	}
};
export default account;
